module.exports = __webpack_public_path__ + "img/visa02.3272f6d0.png";